<div id="contact-us" class="right-navigation showModal" *ngIf="isServiceIncluded">
  <!-- <div (click)="closeModal()" class="empty"></div> -->
  <div class="component">
    <div class="header border-bottom">
      <div class="font-primary-subtitle bold contact-us-header">
        {{ (groupedService.groupName || (groupedService.includedServices[0] | translate:'PACKAGEOBJ':null:null:groupedService.firstService).name ) | translate:'LOCALE':'name' }}
      </div>
      <div (click)="closeModal('CLOSE')" class="float-right closeicon pointer">
        <img src="./assets/icons/close_grey.svg">
      </div>
    </div>

    <div class="content">
        <!-- <div class="info-box">
            <img src="assets/icons/packages/Info.svg" alt="Info" />
            <p>{{'mode_of_service_package_info' | translate}}</p>
        </div> -->
        <div class="instruction-card-content">
          <ng-container *ngIf="selectedPackage?.instructions && (selectedPackage?.instructions | translate : 'LANGARRAY' : 'instruction') as instructions">
          <div class="instruction-card">
            <div class="instruction-content">
              <label>
                <h2 class="section-title">
                  <strong class="text-warning">{{ "HEALTH_PKG#LABEL#INSTRUCTION" | translate }}</strong>
                </h2>
                <p class="text-dark">{{ instructions }}</p>
              </label>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="selectedPackage?.packageDtls?.servicesApplicable?.length > 0">
          <div class="section-header">
            <h2 class="section-title">{{ "HEALTH_PKG#LABEL#SERVICEINCLUDED" | translate }}</h2>
          </div>

          <div class="services-list">
            <ng-container *ngFor="let services of selectedPackage?.packageDtls?.servicesApplicable">
              <div class="service-item" *ngIf="(services | translate : 'PACKAGEOBJ') as service; else NOCONCEPT">
                <img *ngIf="service._directiveRef?.imageUrl" [src]="service._directiveRef.imageUrl" class="service-icon"
                  alt="Service Icon" />
                <label class="service-label">{{ service.name | translate : 'LOCALE' : 'name' }}</label>
              </div>
              <ng-template #NOCONCEPT>
                <div class="service-item">
                  <img src="./assets/icon/dashboard/package.svg" class="service-icon" alt="Default Icon" />
                  <label class="service-label">{{ services.directiveCode + ' - ' + services.conceptCode }}</label>
                </div>
              </ng-template>
            </ng-container>
          </div>
        </ng-container>
        </div>
      </div>
  </div>
</div>
